import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { AnimationStep, CommandBatchService, wait } from 'src/app/services/command-batch.service';

@Component({
  selector: 'app-click-indicator',
  templateUrl: './click-indicator.component.html',
  styleUrl: './click-indicator.component.scss'
})
export class ClickIndicatorComponent implements AfterViewInit, OnDestroy {
  @Input() loop: boolean = false;
  @ViewChild('fadeInAnimation', { read: ElementRef }) fadeInAnimation: ElementRef;
  @ViewChild('fadeOutAnimation', { read: ElementRef }) fadeOutAnimation: ElementRef;
  @ViewChild('clickAnimation', { read: ElementRef }) clickAnimation: ElementRef;
  subs: Subscription[] = [];
  constructor(private cmd: CommandBatchService) {
    this.createAnimationParameters();
    this.subs.push(this.cmd.envChanged$.subscribe({
      next: () => {
        this.createAnimationParameters();
      }
    }));
    this.subs.push(this.cmd.startAnimation$.subscribe({
      next: (step: AnimationStep) => {
        this.runAnimation(step);
      }
    }));
  }

  ngOnDestroy(): void {
    for (let sub of this.subs) {
      sub?.unsubscribe();
    }
  }
  ngAfterViewInit() {
    this.createAnimationParameters();
  }
  runAnimation(ani: AnimationStep) {
    if (!this.cmd._running) {
      return;
    }
    switch (ani) {
      case 'click': {
        this.runClickAnimation();
        break;
      }
      case 'fadeIn': {
        this.runfadeInAnimation();
        break;
      }
      case 'fadeOut': {
        this.runfadeOutAnimation();
        break;
      }
      case 'all': {
        this.run();
        break;
      }
    }
  }
  run() {
    console.log("run all");
    this.runfadeInAnimation();

    wait(this.duration * 0.5).then(
      () => {
        this.runClickAnimation();
        wait(this.duration * 0.25).then(
          () => {
            this.runfadeOutAnimation();
          }
        )
      }
    );
  }
  runfadeInAnimation() {
    console.log("fade-in-animation");
    this.fadeInAnimation?.nativeElement?.beginElement();
  }
  runfadeOutAnimation() {
    console.log("fade-out-animation");
    this.fadeOutAnimation?.nativeElement?.beginElement();
  }
  runClickAnimation() {
    console.log("click-animation");
    this.clickAnimation?.nativeElement?.beginElement();
  }
  animations: any = {};
  steps: { [key: string]: boolean } = {
    fadeIn: true,
    fadeOut: true,
    click: true
  };

  duration: number = 2500;

  createAnimationParameters() {
    let duration = this.cmd.scriptEnv.defaultWait;
    let unit = this.duration / 2250;
    this.animations = {
      FingerFadeIn: {
        begin: 'indefinite',
        duration: (0.75 * unit).toFixed(2) + 's',//'0.75s',
      },
      FingerFadeOut: {
        begin: 'indefinite',
        duration: (0.5 * unit).toFixed(2) + 's',//'0.5s'
      },
      FingerSkew: {
        begin: 'indefinite',
        duration: (0.2 * unit).toFixed(2) + 's',//'0.2s'
      },
      innerCircleGrow: {
        begin: 'FingerSkewX.end-' + (0.1 * unit).toFixed(2) + 's',
        duration: (0.4 * unit).toFixed(2) + 's',//'0.4s'
      },

      innerCircleFade: {
        begin: 'FingerSkewX.end-' + (0.1 * unit).toFixed(2) + 's',
        duration: (0.4 * unit).toFixed(2) + 's'
      },
      outerCircleGrow: {
        begin: 'FingerSkewX.end-' + (0.2 * unit).toFixed(2) + 's',
        duration: (0.4 * unit).toFixed(2) + 's'
      },
      outerCircleFade: {
        begin: 'FingerSkewX.end-' + (0.2 * unit).toFixed(2) + 's',
        duration: (0.4 * unit).toFixed(2) + 's'
      }

    }
  }


}
